import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

const BOOL_COLOR = '#da00bd';

defineBlock({
    type: 'var_get_bool',
    colour: BOOL_COLOR,
    tooltip: '真偽値変数の値を取得します',
    movable: true,
    deletable: true,
    output: 'Boolean',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('変数', { fontSize: 12, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () =>
                        new FieldVariableLabel('flag', {
                            fontWeight: 'normal',
                            varType: 'bool',
                            showSymbol: false,
                        }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('', { minWidth: 0.5 }),
                },
            ],
        },
    ],
});
